import PropTypes from 'prop-types';

import styles from './styles.module.scss';

RSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  firstElement: PropTypes.string,
  containerClassNames: PropTypes.string,
  selectClassNames: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  register: PropTypes.func,
};

export function RSelect({
  id,
  name,
  firstElement,
  containerClassNames,
  selectClassNames,
  options,
  register,
  ...rest
}) {
  return (
    <div className={`${styles.container} ${containerClassNames}`}>
      <select
        id={id}
        name={name}
        className={`input-field ${selectClassNames}`}
        {...register(name)}
        {...rest}
      >
        <option
          value=""
          style={{ display: 'none' }}
          selected
          disabled
        >
          {firstElement}
        </option>

        {options.map((item) => {
          return (
            <option
              key={item}
              value={item}
            >
              {item}
            </option>
          );
        })}
      </select>

      <span className="icon-success">
        <i className="fas fa-check txt-c-green" />
      </span>
    </div>
  );
}
